import { useState, useEffect } from 'react'

import { Stepper, Step, StepLabel } from '@mui/material'

const WizardStepper = ({basePassType, steps, activeStep, setActiveStep}) => {

  const [maxStep, setMaxStep] = useState(0)

  useEffect(() => {
    if (activeStep > maxStep) setMaxStep(activeStep)
  }, [activeStep])

  const handleStepJump = index => {
    if (index <= maxStep) setActiveStep(index)
  }

  return (
    <div className="mt-10 mb-10 pl-5 pr-5">
      <Stepper activeStep={activeStep}>
        {steps[basePassType].map((label, index) => (
          <Step key={label} completed={index <= maxStep} className="link">
            <StepLabel onClick={() => handleStepJump(index)}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>

  )
}

export default WizardStepper